<!--
    AI:
    Status: "in progress"
    Type: Component
    SubType: Shared
    Reason: Summenzeile of a transaction tab: total + count of the run's bookings, and the
            per-Berater totals on demand as a framework widget table (QL groupBy), with the
            "Abrechnung" column (draft/final statement) for the kind agent.
-->
<div class="cp-run-detail-totals surface-ground border-round p-2 mb-2">

    @if (busy && !totals) {
        <p-skeleton height="1.5rem"></p-skeleton>
    } @else if (loadFailed) {
        <div class="flex align-items-center justify-content-between gap-2">
            <span class="text-sm text-red-700">Die Summen konnten nicht geladen werden.</span>
            <p-button icon="fa-regular fa-arrows-rotate" severity="secondary" [text]="true" [rounded]="true"
                      pTooltip="Erneut laden" (onClick)="refreshComponent()"></p-button>
        </div>
    } @else if (totals) {

        <div class="flex align-items-center justify-content-between flex-wrap gap-2">
            <div class="flex align-items-center gap-3 flex-wrap">
                <span class="text-600">Summe</span>
                <span class="text-xl font-semibold text-900">{{ totals.total | currency:'EUR':'symbol':'1.2-2' }}</span>
                <span class="text-600">{{ totals.count }} {{ totals.count === 1 ? 'Buchung' : 'Buchungen' }}</span>
            </div>
            @if (totals.perAgent.length) {
                <p-button [label]="perAgentVisible ? 'Summe je Berater ausblenden' : 'Summe je Berater (' + totals.perAgent.length + ')'"
                          [icon]="perAgentVisible ? 'fa-regular fa-chevron-up' : 'fa-regular fa-chevron-down'"
                          severity="secondary" [text]="true" size="small"
                          (onClick)="togglePerAgent()">
                </p-button>
            }
        </div>

        @if (perAgentVisible && perAgentWidget) {
            <div class="mt-2">
                <mvs-widget #perAgentWidgetRef [widgetData]="perAgentWidget">
                    <ng-template let-object="object" mvs-widget-custom-field-directive
                                 area="columns" [fieldId]="openAccountFieldId" label="Abrechnungskonto">
                        @if (hasAccount(object)) {
                            <p-button icon="fa-regular fa-arrow-up-right-from-square"
                                      severity="secondary" [text]="true" [rounded]="true" size="small"
                                      pTooltip="Abrechnungskonto öffnen" tooltipPosition="left"
                                      (onClick)="openAccount(object)">
                            </p-button>
                        }
                    </ng-template>
                    <!-- "Abrechnung" (kind agent, GR-S1): draft download / final download / create.
                         Statement existence comes from ONE lookup per run, the widget is not rebuilt for it. -->
                    <ng-template let-object="object" mvs-widget-custom-field-directive
                                 area="columns" [fieldId]="agentStatementFieldId" label="Abrechnung">
                        @if (agentIdOf(object)) {
                            @switch (statementMode) {
                                @case ('draft') {
                                    <p-button icon="fa-regular fa-file-pdf"
                                              severity="secondary" [text]="true" [rounded]="true" size="small"
                                              pTooltip="Entwurf herunterladen" tooltipPosition="left"
                                              [loading]="isStatementBusy(object)"
                                              [disabled]="isStatementBusy(object)"
                                              (onClick)="downloadDraft(object)">
                                    </p-button>
                                }
                                @case ('final') {
                                    @if (statementLookupFailed) {
                                        <p-button icon="fa-regular fa-arrows-rotate"
                                                  severity="danger" [text]="true" [rounded]="true" size="small"
                                                  pTooltip="Abrechnungsstand konnte nicht geladen werden – erneut laden"
                                                  tooltipPosition="left"
                                                  (onClick)="reloadStatements()">
                                        </p-button>
                                    } @else if (!statementsByAgent) {
                                        <p-skeleton width="8rem" height="1.5rem"></p-skeleton>
                                    } @else if (statementOf(object); as statement) {
                                        <p-button label="Abrechnung herunterladen" icon="fa-regular fa-file-arrow-down"
                                                  severity="secondary" [text]="true" size="small"
                                                  [pTooltip]="'Provisionsabrechnung ' + (statement.statementNumber ?? '') + ' herunterladen'"
                                                  tooltipPosition="left"
                                                  [loading]="isStatementBusy(object)"
                                                  [disabled]="isStatementBusy(object)"
                                                  (onClick)="downloadFinal(object)">
                                        </p-button>
                                    } @else {
                                        <p-button label="Abrechnung erstellen" icon="fa-regular fa-file-circle-plus"
                                                  severity="primary" [text]="true" size="small"
                                                  [pTooltip]="canCreateAgentStatement
                                                      ? 'Finale Provisionsabrechnung erstellen'
                                                      : 'Ihnen fehlt die Berechtigung, Provisionsabrechnungen zu erstellen (cp_agentStatement).'"
                                                  tooltipPosition="left"
                                                  [loading]="isStatementBusy(object)"
                                                  [disabled]="isStatementBusy(object) || !canCreateAgentStatement"
                                                  (onClick)="createFinal(object)">
                                        </p-button>
                                    }
                                }
                            }
                        }
                    </ng-template>
                </mvs-widget>
            </div>
        }
    }

</div>
